import { render, staticRenderFns } from "./historic.vue?vue&type=template&id=9dfeabb0&scoped=true&"
import script from "./historic.js?vue&type=script&lang=js&"
export * from "./historic.js?vue&type=script&lang=js&"
import style0 from "./historic.vue?vue&type=style&index=0&id=9dfeabb0&prod&lang=scss&"
import style1 from "./historic.vue?vue&type=style&index=1&id=9dfeabb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfeabb0",
  null
  
)

export default component.exports